import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DISCOUNT_CODE_CATEGORY_PATH } from '../../../../config/paths';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import Table from '../../../common/Table';
import { DISCOUNT_CODE_SUB_CATEGORY_COLUMN } from '../../../../config/columns';
import Alert from '../../../common/informative/Alert';
import { GENERIC_NO_DATA_MESSAGE } from '../../../../config/messages';
import {
  clearDiscountCodeCategory,
  getDiscountCodeCategory,
} from '../../../../actions/sales/DiscountCodeCategory';
import DiscountCodeCategoryBasicInformationResource from './resources/DiscountCodeCategoryBasicInformationResource';
import DiscountCodeCategoryToolbar from './DiscountCodeCategoryToolbar';

export const DiscountCodeCategory = ({
  breadcrumbs,
  dispatchClearDiscountCodeCategory,
  dispatchGetDiscountCodeCategory,
  match: {
    params: { id: discountCodeCategoryId },
  },
  loading,
  discountCodeCategory,
}) => {
  useLayoutEffect(() => {
    dispatchGetDiscountCodeCategory({ discountCodeCategoryId });

    return () => dispatchClearDiscountCodeCategory();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (discountCodeCategory.isEmpty())
    content = <NoDataResource returnPage={DISCOUNT_CODE_CATEGORY_PATH} />;
  else {
    const discountCodeCategoryJson = discountCodeCategory.toJS();

    const tableSubCategory =
      discountCodeCategoryJson.discountCodeSubCategoryList !== null &&
      discountCodeCategoryJson.discountCodeSubCategoryList.length !== 0 ? (
        <Table
          columns={DISCOUNT_CODE_SUB_CATEGORY_COLUMN}
          data={discountCodeCategoryJson.discountCodeSubCategoryList}
          showPagination={false}
          defaultPageSize={
            discountCodeCategoryJson.discountCodeSubCategoryList.length
          }
        />
      ) : (
        <Alert type="warning" message={GENERIC_NO_DATA_MESSAGE} />
      );
    content = (
      <>
        <div className="row mb-4">
          <div className="col-md-8">
            <h3>Información Básica</h3>
            <DiscountCodeCategoryBasicInformationResource
              discountCodeCategory={discountCodeCategoryJson}
            />
          </div>
        </div>
        <div className="mt-4">
          <h3>Subcategorías</h3>
          {tableSubCategory}
        </div>
      </>
    );

    toolbar = (
      <DiscountCodeCategoryToolbar
        discountCodeCategoryId={discountCodeCategoryJson.id}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Categoría de Código de Descuento"
      content={content}
    />
  );
};

DiscountCodeCategory.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearDiscountCodeCategory: PropTypes.func.isRequired,
  dispatchGetDiscountCodeCategory: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  discountCodeCategory: PropTypes.instanceOf(Immutable.Map).isRequired,
};

DiscountCodeCategory.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearDiscountCodeCategory: clearDiscountCodeCategory,
  dispatchGetDiscountCodeCategory: getDiscountCodeCategory,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Categoría de Códigos de Descuento',
      href: DISCOUNT_CODE_CATEGORY_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  discountCodeCategory: SalesUnit.DiscountCodeCategory.getIn([
    'current',
    'content',
  ]),
  loading: !SalesUnit.DiscountCodeCategory.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DiscountCodeCategory);
